var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgHealth(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 100,
    height: 100,
    viewBox: "0 0 100 100",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M50.0978 74C50.0978 74 31.3217 62.1917 22.9117 50.9642H36.2114C36.7981 50.9642 37.3848 50.577 37.5805 49.9963L39.7319 46.5119L44.4259 62.7725C44.8171 64.3211 47.164 64.3211 47.5552 62.7725L54.4007 38.9624L60.0726 56.1908C60.4638 57.5459 62.224 57.7395 63.0063 56.578L66.7224 50.9642H77.0883C68.6783 62.1917 50.0978 74 50.0978 74ZM20.9558 47.6734C19.7824 45.544 19 43.4147 19 41.4789C19 21.3468 42.2745 16.1202 50.0978 29.09C57.7255 16.1202 81 21.3468 81 41.4789C81 43.4147 80.4133 45.544 79.2398 47.6734H65.94C65.3533 47.6734 64.9621 48.0605 64.571 48.4477L62.0284 52.1257L55.9653 33.1551C55.3786 31.6065 53.2271 31.6065 52.836 33.1551L45.9905 56.7716L41.6877 42.2532C41.2965 40.8982 39.5362 40.7046 38.9495 41.8661L35.2334 47.6734H20.9558Z",
    fill: "black"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHealth);
export default __webpack_public_path__ + "static/media/health.0b4443f5af18e405a8c9d61c4d9c4326.svg";
export { ForwardRef as ReactComponent };